import { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const CACHE_KEY_PROFILE = "cachedProfileData";

const ProfilePage = () => {
  const [userData, setUserData] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY_PROFILE)) || null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(!userData);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [bankDetails, setBankDetails] = useState(userData?.bankDetails || "");

  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userRef = doc(db, "affiliates", user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const profileData = userSnap.data();
        setUserData(profileData);
        setBankDetails(profileData.bankDetails || "");
        localStorage.setItem(CACHE_KEY_PROFILE, JSON.stringify(profileData));
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  const handleSaveBankDetails = async () => {
    if (!auth.currentUser) return;

    try {
      const userRef = doc(db, "affiliates", auth.currentUser.uid);
      await updateDoc(userRef, {
        bankDetails: bankDetails,
      });
      const updatedProfile = { ...userData, bankDetails };
      setUserData(updatedProfile);
      localStorage.setItem(CACHE_KEY_PROFILE, JSON.stringify(updatedProfile));
      setEditDialogOpen(false);
    } catch (error) {
      console.error("Error updating bank details:", error);
    }
  };

  if (loading) return <Typography>Loading...</Typography>;
  if (!userData) return <Typography>No profile data found.</Typography>;

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Profile
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6">Name:</Typography>
          <Typography>{userData.name}</Typography>
          <Typography variant="h6" mt={2}>
            Email:
          </Typography>
          <Typography>{userData.email}</Typography>
          <Typography variant="h6" mt={2}>
            Bank Details:
          </Typography>
          {typeof userData.bankDetails === "string" ? (
            <>
              <Typography>{userData.bankDetails}</Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setEditDialogOpen(true)}
              >
                Edit Bank Details
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setEditDialogOpen(true)}
            >
              Add Bank Details
            </Button>
          )}
        </CardContent>
      </Card>

      <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
        <DialogTitle>Edit Bank Details</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Bank Details"
            variant="outlined"
            value={bankDetails}
            onChange={(e) => setBankDetails(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleSaveBankDetails}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ProfilePage;
